import { render, staticRenderFns } from "./FoundationTitleCreate.vue?vue&type=template&id=0233eb5c"
import script from "./FoundationTitleCreate.vue?vue&type=script&lang=js"
export * from "./FoundationTitleCreate.vue?vue&type=script&lang=js"
import style0 from "./FoundationTitleCreate.vue?vue&type=style&index=0&id=0233eb5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports